import { render, staticRenderFns } from "./materiallist.vue?vue&type=template&id=8827a708&scoped=true"
import script from "./materiallist.vue?vue&type=script&lang=js"
export * from "./materiallist.vue?vue&type=script&lang=js"
import style0 from "./materiallist.vue?vue&type=style&index=0&id=8827a708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8827a708",
  null
  
)

export default component.exports